import React from 'react';
import UsersByRole from './UsersByRole';

const AirbnbHosts = () => (
  <UsersByRole
    role="BNB_HOST"
    title="Airbnb Hosts"
    subtitle="View and search short-stay BnB owners on the platform."
    detailBasePath="/system-admin/airbnb-hosts"
  />
);

export default AirbnbHosts;
